import { createSelector } from "reselect";
import { createAction } from "redux-actions";
import { path } from "ramda";

export const SET_EDIT_MODE = "APP@MATERIAL::EDIT_MODE::SET";
export const setEditMode = createAction(SET_EDIT_MODE);

export const selectIsEditMode = createSelector(
  path(["application", "materials", "isEditMode"]),
  isEditMode => isEditMode
);

const initialState = () => false;

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case SET_EDIT_MODE:
      return action.payload;
    default:
      return state;
  }
}
